import React, { useContext, useState } from 'react';

import { BoxButton, Button, TextButton, XButton } from '@riac/design-system';
import { Input } from '@riac/design-system';
import {
  SecondaryP,
} from 'src/components/PlaceBid/PlaceBid.style';
import { IControlledWLItem, IWLItem } from 'src/components/Wishlists/Wishlist.i';
import { WishlistItem } from 'src/components/Wishlists/WishlistItem.style';
import { formatCurrency } from 'src/lib/catalog';
import { WishlistActionContext } from 'src/lib/WishlistActionContext';
import { BiddingContext } from 'src/lib/BiddingContext';

// parent handles Notes field state
export const ControlledWLItem = (props: IControlledWLItem) => {
  const { notes, setNotes, notesOpen, item } = props;
  const [editNotes, setEditNotes] = useState(notesOpen ? true : false);
  const { saveWishlistItemNotes, deleteWishlistItem } = useContext(WishlistActionContext);
  const img = `${window.CDN_PATH}${item.AuctionID}/thumbs/${item.LotNumber}.jpg`;
  const link = `/detail/${item.AuctionID}/${item.LotNumber}`;
  const { auctionTypeId } = useContext(BiddingContext);
  return (
    <WishlistItem>
      <div>
        <Button to={link}>
          <img src={img} alt={`Rock Island Auction Company Lot Number ${item.LotNumber}`} />
        </Button>
        <div>
          <p>
            <TextButton to={link}>
              Lot {item.LotNumber}: <SecondaryP as='span'>{item.Headline}</SecondaryP>
            </TextButton>
          </p>
          {auctionTypeId !== TIMED_AUCTION_TYPE_ID
          && <p>
            Estimated Price:{' '}
            <SecondaryP as='span'>
              {formatCurrency(item.LowEst)} -{formatCurrency(item.HighEst)}
            </SecondaryP>
          </p>
          }
          {notes && !editNotes && (
            <p>
              Notes: <SecondaryP as='span'>{notes}</SecondaryP>
            </p>
          )}
          {editNotes ? (
            <>
              <Input
                label='Notes:'
                type='textarea'
                value={notes || ''}
                inverted
                onChange={(e) => setNotes(e)}
              />
              {props.type === 'view' ? (
                <BoxButton
                  onPress={() => {
                    saveWishlistItemNotes(item.WishListItemID, notes);
                    setEditNotes(false);
                  }}
                >
                  Save
                </BoxButton>
              ) : null}
            </>
          ) : (
            <p>
              <TextButton onPress={() => setEditNotes((status) => !status)}>
                <u>{notes?.length > 0 ? 'Edit' : 'Add'} Note</u>
              </TextButton>
            </p>
          )}
        </div>
      </div>
      {props.type === 'view' ? (
        <XButton
          title='Remove Item'
          onPress={() => {
            deleteWishlistItem(item.WishListItemID, props.wishlistId, item.AuctionItemID);
            props.removeFromList(item.WishListItemID);
          }}
        />
      ) : null}
    </WishlistItem>
  );
};

// WL item with self-contained Notes state
export const WLItem = (props: IWLItem) => {
  const [note, setNote] = useState(props.item.Notes);
  return (
    <ControlledWLItem
      type='view'
      notes={note}
      setNotes={setNote}
      notesOpen={false}
      item={props.item}
      wishlistId={props.wishlistId}
      removeFromList={props.removeFromList}
    />
  );
};
